import { useEffect, useState } from "react";
import firebase from "firebase/compat";

export const useAuthAdmin = (user: firebase.User | null): boolean => {
  const [isAdmin, setAdmin] = useState<boolean>();

  useEffect(() => {
    user
      ?.getIdTokenResult()
      .then((idTokenResult) => {
        setAdmin(!!idTokenResult.claims.admin);
      })
      .catch((error) => {
        console.warn("Failed to check admin status:", error);
        setAdmin(false);
      });
  }, [user]);

  return isAdmin ?? false;
};
